"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mkPageViewData = void 0;
var r = function (f) {
    try {
        var o = f();
        return typeof o == typeof true && o != null ? +o : o;
    }
    catch (e) {
        return null;
    }
};
var mkPageViewData = function (portal_lang) {
    try {
        var d = {
            tz: -new Date().getTimezoneOffset(),
            nt: r(function () { var _a; return ((_a = window.navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType) || null; }),
            ns: r(function () { var _a; return ((_a = window.navigator.connection) === null || _a === void 0 ? void 0 : _a.downlink) || null; }),
            vw: r(function () { return window.innerWidth; }),
            vh: r(function () { return window.innerHeight; }),
            sw: r(function () { return window.screen.width; }),
            sh: r(function () { return window.screen.height; }),
            pl: portal_lang,
            sr: r(function () { return window.devicePixelRatio; }),
            url: window.location.href,
        };
        return d;
    }
    catch (e) {
        console.log(e);
    }
};
exports.mkPageViewData = mkPageViewData;
